// Set version number and date in the environment.store.ts file

export const environment = {
  production: true,
  baseUrl: 'https://wholesaler-api-test-cch6ateuhxhqgmd4.westus-01.azurewebsites.net',
  context: 'test',
};
